import BasicLayout from '@/layouts/basic-layout'

const prefix = 'fin-actual-payable-'
export default {
  path: '/financial-manage/fin-actual-payable',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {title: '实付管理-承'},
      component: () => import('@/pages/financial-manage/fin-actual-payable/index')
    },
    {
      path: 'detail-create',
      name: `${prefix}create`,
      auth: ['hidden'],
      meta: {title: '实付申请新增-承'},
      component: () => import('@/pages/financial-manage/fin-actual-payable/detail-create')
    },
    {
      path: 'detail-edit/:id',
      name: `${prefix}edit`,
      auth: ['hidden'],
      meta: {title: '实付申请编辑-承'},
      component: () => import('@/pages/financial-manage/fin-actual-payable/detail-edit')
    },
    {
      path: 'detail-view/:id',
      name: `${prefix}view`,
      auth: ['hidden'],
      meta: {title: '业主合同收付款情况详情-承'},
      component: () => import('@/pages/financial-manage/fin-actual-payable/detail-view')
    }
  ]
}
